import { useNavigate } from "react-router-dom";
import { IoReturnUpBackOutline } from "react-icons/io5";
import data from "../data/MentionsLegalesData";
import "../style/MentionsLegales.css";

function MentionsLegales() {
    const navigate = useNavigate();
    return (
        <div className="main">
            <div className="main-content">
                <IoReturnUpBackOutline
                className="back-icon top"
                onClick={() => navigate("/")}
                />
               <div className="center-elm">
                    <h1 className="header-title h1">Mentions légales</h1>
                    <div className="faq-cards">
                        <div className="faq-card bg">
                            <table>
                            {
                                data.map(mention => <tr 
                                    key={mention.id}
                                >          
                                    <td>
                                        <h1 className="title">{mention.title}</h1>
                                    </td>
                                    <td className="separator-table">
                                        <h1 className="title"> : </h1>
                                    </td>
                                    <td>
                                        <p className="description">{mention.description}</p>
                                    </td>
                                </tr> 
                                )
                            }
                            </table>
                            <div className="div-explore">
                                <a href="https://jway.ma/" class="explore-btn-mention">Notre Site Web</a>
                            </div>
                        </div>
                    </div>
               </div>   
            </div>
        </div>
    );
}

export default MentionsLegales;